import { Button } from 'avo-ui'
import Select from 'components/commons/select'
import Search from 'components/commons/search'
import Sort from 'components/commons/sort'
import PageLimit from 'components/commons/page-limit'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import icSync from 'assets/images/ic-sync.svg'
import { SORT_PRODUCT, TABLE_PRODUCT } from 'configs/product/configTableProductList'
import Table from 'components/commons/table'
import ModalExport from 'components/commons/modal-export'
import ModalConfirmation from 'components/commons/modal-confirmation'
import ModalDelete from 'components/commons/modal-delete'
import { AdvanceFilterContainer } from '../../../containers/product/product-list/AdvanceFilterContainer'
import { SyncProductContainer } from '../../../containers/product/product-list/SyncProductContainer'

export const ProductList = ({
    dataList,
    modal,
    setShowModal,
    onSelectSort,
    query,
    onChangeQuery,
    queryFilter,
    onFilter,
    onApply,
    modalMessage,
    onConfirm,
    selectedIds,
    statusOptions,
    selectedStatus,
    onChangeStatus,
    onExport,
    onSelectItemHandler,
    isLoading,
    isExporting,
    isBulkAction,
    isResetSelectedItem,
    onSyncCompleted,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex space-x-3'}>
                    <div className={'flex space-x-3'}>
                        <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                        <Sort
                            options={SORT_PRODUCT}
                            value={`${query?.order_by}-${query?.order_type}`}
                            onSelect={(value) => onSelectSort(value)}
                        />
                    </div>
                    <AdvanceFilterContainer
                        show={modal?.filter}
                        setShow={(value) => setShowModal({ filter: value })}
                        values={queryFilter}
                        onSubmit={(value) => onFilter(value)}
                    />
                    <div className={'flex space-x-3'}>
                        <PageLimit
                            value={query?.limit}
                            onSelect={(value) => onChangeQuery({ page: 1, limit: value })}
                        />
                        <Button
                            title={'Export'}
                            icon={icLinkExternal}
                            type={'outline'}
                            disabled={!dataList?.total_result}
                            onClick={() => setShowModal({ export: true })}
                        />
                        <Button
                            title={'Sync Product'}
                            type={'outline'}
                            icon={icSync}
                            onClick={() => setShowModal({ sync: true })}
                        />
                    </div>
                </div>
                <div className={'flex space-x-3'}>
                    <Select
                        name={'status'}
                        className={'w-32'}
                        placeholder={'Select Status'}
                        options={statusOptions}
                        value={selectedStatus}
                        onChange={onChangeStatus}
                    />
                    <Button title={'Apply'} onClick={onApply} disabled={!selectedIds?.length} />
                </div>
            </div>
            <Table
                className={'my-3'}
                name={TABLE_PRODUCT.name}
                columns={TABLE_PRODUCT.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={selectedIds?.length || dataList?.total_result}
                    isLoading={isExporting}
                    onExport={onExport}
                />
            )}
            {modal?.confirm && (
                <ModalConfirmation
                    show={modal?.confirm}
                    onHide={() => setShowModal({ confirm: false })}
                    description={modalMessage}
                    totalData={selectedIds?.length}
                    isLoading={isBulkAction}
                    onConfirm={onConfirm}
                />
            )}
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={modalMessage}
                    totalData={selectedIds?.length}
                    isLoading={isBulkAction}
                    onDelete={onConfirm}
                />
            )}
            {modal?.sync && ( 
                <SyncProductContainer 
                    show={modal?.sync} 
                    onHide={() => setShowModal({ sync: false })} 
                    selectedIds={selectedIds}
                    onSyncCompleted={onSyncCompleted} 
                />
            )}
        </div>
    )
}
